<template>
  <div>
    <Head :title="form.name"/>
    <div class="flex justify-start mb-8">
      <h1 class="text-3xl font-bold">
        {{ $t('ui.profile') }}
        <span class="text-indigo-400 font-medium mx-2">/</span>
        {{ form.name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo"/>
    </div>

    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
      {{ $t('alerts.current_model_deleted', [$t('models.user')]) }}
    </trashed-message>

    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name"
                      class="pb-8 pr-6 w-full" :label="$t('fields.user.name')" autofocus/>
          <text-input v-model="form.mobile" :error="form.errors.mobile"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.user.mobile')"/>
          <text-input v-model="form.email" :error="form.errors.email"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.user.email')"/>
          <text-input v-model="form.password" :error="form.errors.password"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="password"
                      autocomplete="new-password" :label="$t('fields.user.password')"/>
          <text-input v-model="form.password_confirmation"
                      :error="form.errors.password_confirmation"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="password"
                      autocomplete="new-password" :label="$t('fields.user.password_confirmation')"/>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto"
                          type="submit">
            {{ $t('actions.save') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Layouts/Authenticated'
import TextInput from '@/Inputs/TextInput'
import FileInput from '@/Inputs/FileInput'
import SelectInput from '@/Inputs/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    roles: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.user.name,
        mobile: this.user.mobile,
        email: this.user.email,
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.post(route('profile.update'), {
        onSuccess: () => this.form.reset('password', 'password_confirmation'),
      })
    },
  },
}
</script>
